import '../App.css';
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { useState } from "react";
import main_Logo from '../assets/images/logo.png';
import Logo from '../assets/images/brainium.png';
import background from "../assets/images/banner-bg.jpeg";
import Logo3 from '../assets/images/leadorchard.png';
import Logo4 from '../assets/images/rishabh.png';
import Logo5 from '../assets/images/technolabs.png';
import Logo6 from '../assets/images/tinkerly.png';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { hire, pro, str, time, userDetails } from './slice';

function HireTalent6() {
  const navigate = useNavigate()
  const dispatch = useDispatch()



  const prevButton = () => {
    dispatch(hire({}))
    dispatch(str(''))
    dispatch(pro(''))
    dispatch(time(''))
    dispatch(userDetails({}))
    navigate("/")
  }


  const hire_talent_bg = {

    backgroundImage: `url(${background})`,
    height: '100vh',
    width: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
  };

  return (


    <>
      <div className='hire_talent_wrapper'>
        <Row>
          <Col md={7} xs={12}>
            <div className="hire_talent_content">
              <Container>
                <div className="top_head text-center">
                  <img src={main_Logo} alt="Logo" />
                  <h4>Thank you for your interest.</h4>
                  <p>We do not yet offer top talent in India</p>
                </div>
                <Row className='card_padding'>
                  <Card.Footer className="d-flex justify-content-between">
                    <Button onClick={prevButton}>Start Over</Button>
                  </Card.Footer>
                </Row>
              </Container>
            </div>
          </Col>
          <Col md={5} xs={12}>
            <div className="hire_talent_right_wrapper" style={hire_talent_bg}>
              <div className="hire_talent_logo">
                <div>
                  <h3>TRUSTED BY</h3>
                  <ul>
                    <li><img src={Logo} alt="fire icon" /></li>
                    <li><img src={Logo3} alt="fire icon" /></li>
                    <li><img src={Logo4} alt="fire icon" /></li>
                    <li><img src={Logo5} alt="fire icon" /></li>
                    <li><img src={Logo6} alt="fire icon" /></li>
                    <li><img src={Logo} alt="fire icon" /></li>
                    <li><img src={Logo3} alt="fire icon" /></li>
                    <li><img src={Logo4} alt="fire icon" /></li>
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>



  );
}

export default HireTalent6;